import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { ICON, ICON_SIZE } from "./constants";

export type IconSize = keyof typeof ICON_SIZE;

export type IconName = keyof typeof ICON;

export const getFontSize = (size: IconSize) => ICON_SIZE[size] || ICON_SIZE.md;

const getIcon = (name: IconName) => ICON[name] || ICON.imageSlash;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)<{
  $fontSize: number;
  $primaryColor: string;
  $secondaryColor?: string;
}>`
  --fa-secondary-opacity: 1;

  ${(props) => css`
    font-size: ${props.$fontSize}px;
    color: ${props.$primaryColor};
    --fa-primary-color: ${props.$primaryColor};
    --fa-secondary-color: ${props.$secondaryColor};
  `}
`;

interface Props {
  name: IconName;
  size?: IconSize;
  height?: number;
  color?: string;
  reverse?: boolean;
  bgFill?: string;
}

const Icon: React.FC<Props> = ({
  name,
  size = "sm" as IconSize,
  height,
  color, // Key in theme.colors
  reverse, // Use theme.reverseColors instead
  bgFill, // duotone icons only
  ...props
}) => {
  const theme = useTheme();
  const iconFontSize = height || getFontSize(size);
  // TODO: Remove fallback to imported theme
  const primaryColor =
    theme[reverse ? "reverseColors" : "colors"][color] || color;
  const secondaryColor = theme.colors[bgFill] || bgFill;
  return (
    <StyledFontAwesomeIcon
      icon={getIcon(name)}
      $fontSize={iconFontSize}
      $primaryColor={primaryColor}
      $secondaryColor={secondaryColor}
      {...props}
    />
  );
};

export default Icon;
